import { useEffect, useRef, useState } from 'react';
import '../features/projects/home.css';

export function useCountUp(target: number, precision = 0) {
  const [value, setValue] = useState(target);
  const from = useRef(0);
  useEffect(() => {
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const start = from.current;
    from.current = target;
    if (reduced || document.hidden || start === target) { setValue(target); return; }
    const scale = 10 ** precision;
    let frame = 0;
    const began = performance.now();
    const tick = (now: number) => {
      const t = Math.min(1, (now - began) / 480);
      setValue(Math.round((start + (target - start) * (1 - Math.pow(1 - t, 3))) * scale) / scale);
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, precision]);
  return value;
}

interface Props {
  label: string;
  value: number;
  loading: boolean;
  precision?: number;
  format?: (value: number) => string;
  detail?: string;
  tone?: 'warning';
  active?: boolean;
  onClick?: () => void;
}

export default function FloorStat({ label, value, loading, precision = 0, format = String, detail, tone, active, onClick }: Props) {
  const shown = useCountUp(loading ? 0 : value, precision);
  const body = <>
    <span className="studio-stat-value bs-mono">{loading ? '—' : format(shown)}</span>
    <span className="studio-stat-label">{label}</span>
    {detail && !loading && <span className="studio-stat-detail bs-mono">{detail}</span>}
  </>;
  if (!onClick) return <div className={`studio-stat${tone ? ` studio-stat--${tone}` : ''}`}>{body}</div>;
  return <button type="button" className="studio-stat studio-stat--action" aria-pressed={active} onClick={onClick}>{body}</button>;
}
